import { Component, OnInit, Output, EventEmitter, ElementRef, ViewChild, Input, OnDestroy } from '@angular/core';

/**
 * https://netbasal.com/build-an-infinite-scroll-component-in-angular-a9c16907a94d
 */
@Component({
  selector: 'infinite-scroll',
  template: '<div class="anchor" #anchor></div><ng-content></ng-content>',
  standalone: true,
  styleUrls: ['./Infinite-scroll.component.scss']
})
export class InfiniteScrollComponent implements OnInit, OnDestroy {
    @Input() public options = {};
    @Output() public scrolled = new EventEmitter();
    @ViewChild('anchor', {static: true}) public anchor: ElementRef<HTMLElement> | undefined

    private observer: IntersectionObserver | undefined;

    constructor(private host: ElementRef) { }

    get element() {
        return this.host.nativeElement;
    }

    public ngOnInit(): void {
        const options = {
            root: this.isHostScrollable() ? this.host.nativeElement : null,
            threshold: 1,
            ...this.options
        };

        this.observer = new IntersectionObserver(([entry]) => {
            entry.isIntersecting && this.scrolled.emit();
        }, options);

        this.observer.observe(this.anchor!.nativeElement);
    }

    public ngOnDestroy(): void {
        this.observer!.disconnect();
    }

    private isHostScrollable() {
        const style = window.getComputedStyle(this.element);

        return style.getPropertyValue('overflow') === 'auto' ||
            style.getPropertyValue('overflow-y') === 'scroll';
    }
}
